import { Component, OnInit } from "@angular/core";
import * as $ from "jquery";
import { CentralService } from "../servicios/central.service";
import {
  faSignInAlt,
  faKey,
  faEuroSign,
  faTractor,
  faMoneyBill,
  faFileInvoice,
  faCheckCircle,
  faCalendarAlt,
  faFileAlt,
} from "@fortawesome/free-solid-svg-icons";
import { Router } from "@angular/router";
import { AvisosComponent } from "../avisos/avisos.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { faArrowRight, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
// Importa NgbDateStruct si usas ngbDatepicker
// import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: "app-piensos",
  templateUrl: "./piensos.component.html",
  styleUrls: ["./piensos.component.css"],
})
export class PiensosComponent implements OnInit {
  // Iconos existentes...
  icoEntr = faSignInAlt;
  icoKey = faKey;
  icoEur = faEuroSign;
  icoTra = faTractor;
  icoMny = faMoneyBill;
  icoInv = faFileInvoice;
  icoVal = faCheckCircle;
  icoFec = faCalendarAlt;
  icoFac = faFileAlt;

  // Iconos para el wizard
  faArrowRight = faArrowRight;
  faArrowLeft = faArrowLeft;

  fecdia: string;
  nomusu: string;
  menu: any;
  iconos = [
    this.icoKey,
    this.icoEur,
    this.icoTra,
    this.icoMny,
    this.icoInv,
    this.icoFac,
  ];

  modoLis = 0;
  formLis = 0;
  SwDetal = false;
  SwTotal = false;
  SwExcel = false;
  SwImpre = false;
  SwLista = false;
  SwGrafi = false;
  resul: boolean = false;

  prifec: string;
  ultfec: string;

  pasoActual = 1;

  fincas: any[] = [];

  piensos: any[] = [];

  pasos: any[] = [];

  entregaData = {
    finca: "",
    nomUsu: "",
    codUsu: "",
    marcas: [] as {
      ttcodmar: number;
      ttdesmar: string;
      tipos: {
        ttcodtip: number;
        ttdestip: string;
        cantidad: number | null;
      }[];
    }[],
    formato: "",
    observaciones: "",
    fecha: null,
  };
  usuarioActual: any;
  opcionesMarca = [
    { valor: "tipoA", texto: "Tipo A" },
    { valor: "tipoB", texto: "Tipo B" },
    { valor: "tipoC", texto: "Tipo C" },
  ];

  constructor(
    private srvCentral: CentralService,
    private router: Router,
    private modalService: NgbModal,
  ) {}

  ngOnInit(): void {
    const now = new Date();
    this.fecdia = now.toLocaleString("es-ES");
    this.nomusu = this.srvCentral.datosIden.UsuNom;

    // Menu
    if (this.srvCentral.datosIden.UsuUsu !== "") {
      const k = this.srvCentral.listaMnu.length;
      this.menu = [];
      for (let i = 0; i < k; i++) {
        this.menu.push({
          nombre: this.srvCentral.listaMnu[i].nombre,
          ruta: this.srvCentral.listaMnu[i].ruta,
          icono: this.iconos[this.srvCentral.listaMnu[i].ico],
        });
      }
    }
    this.entregaData.nomUsu = this.nomusu;
    this.usuarioActual = localStorage.getItem("usuarioActual");
    this.entregaData.codUsu = JSON.parse(this.usuarioActual || "{}").codUsu;
    // console.log("Usuario actual:", this.entregaData.codUsu);

    this.srvCentral.consulFinca(this.entregaData.codUsu).subscribe((datos) => {
      this.fincas = datos;
    });

    this.srvCentral.consulPiensos("@").subscribe((datos) => {
      const agrupado: any[] = [];

      datos.forEach((d: any) => {
        let marca = agrupado.find((m) => m.ttcodmar === d.ttcodmar);
        if (!marca) {
          marca = {
            ttcodmar: d.ttcodmar,
            ttdesmar: d.ttdesmar,
            tipos: [],
          };
          agrupado.push(marca);
        }

        marca.tipos.push({
          ttcodtip: d.ttcodtip,
          ttdestip: d.ttdestip,
          cantidad: 0,
        });
      });

      this.piensos = agrupado;

      this.entregaData.marcas = this.piensos.map((marca) => ({
        ttcodmar: marca.ttcodmar,
        ttdesmar: marca.ttdesmar,
        tipos: marca.tipos.map((tipo) => ({
          ttcodtip: tipo.ttcodtip,
          ttdestip: tipo.ttdestip,
          cantidad: 0,
        })),
      }));

      this.pasos = [
        { tipo: "finca" },
        ...this.entregaData.marcas.map((marca) => ({ tipo: "pienso", marca })),
        { tipo: "formato" },
        { tipo: "observaciones" },
      ];
    });
  }

  fincaValida(): boolean {
    return this.entregaData.finca.trim() !== "";
  }

  marcaValida(): boolean {
    return this.entregaData.marcas.some((marca) =>
      marca.tipos.some((tipo) => tipo.cantidad && tipo.cantidad > 0),
    );
  }

  formatoValido(): boolean {
    return (
      this.entregaData.formato === "granel" ||
      this.entregaData.formato === "envasado"
    );
  }

  fechasValidas(): boolean {
    return this.entregaData.fecha !== null;
  }

  seleccionarFormato(formato: "granel" | "envasado") {
    this.entregaData.formato = formato;
  }

  siguientePaso() {
    const paso = this.pasos[this.pasoActual - 1];

    if (!paso) return;

    switch (paso.tipo) {
      case "finca":
        if (this.fincaValida()) this.pasoActual++;
        break;
      case "pienso":
        this.pasoActual++;
        break;
      case "formato":
        if (this.formatoValido()) this.pasoActual++;
        break;
      case "observaciones":
        this.pasoActual++;
        break;
    }
  }

  anteriorPaso() {
    if (this.pasoActual > 1) {
      this.pasoActual--;
    }
  }

  enviarEntrega() {
    if (this.fechasValidas()) {
      this.resul = true;

      const fechaObj = new Date();
      const dia = String(fechaObj.getDate()).padStart(2, "0");
      const mes = String(fechaObj.getMonth() + 1).padStart(2, "0");
      const anyo = fechaObj.getFullYear();
      const fechaFormateada = `${dia}/${mes}/${anyo}`;

      const lineas = [];
      const ttForma = this.entregaData.formato === "granel" ? 1 : 0;
      // console.log("Entregas para progress:", this.entregaData);

      this.entregaData.marcas.forEach((marca) => {
        marca.tipos.forEach((tipo) => {
          console.log("Tipo actual:", tipo);
          console.log("codigo actual:", this.entregaData.codUsu);

          //if (tipo.cantidad && tipo.cantidad >= 0) {
          lineas.push({
            ttSocio: this.entregaData.codUsu,
            ttFecha: fechaFormateada,
            ttExplo: this.entregaData.finca,
            ttMarca: marca.ttcodmar,
            ttTipo: tipo.ttcodtip,
            ttCanti: tipo.cantidad,
            ttForma: ttForma,
          });
          //}
        });
      });

      // console.log("Líneas a enviar a Progress:", lineas);

      this.srvCentral.entregaPiensos(0, lineas).subscribe({
        next: (resp) => {
          this.resul = false;
          //  console.log("Respuestas Progress:", resp);
          alert("Entrega de piensos registrada correctamente");
          this.reiniciarFormulario();
        },
        error: (err) => {
          this.resul = false;
          console.error("Error en entrega:", err);
          alert("Error registrando la entrega");
        },
      });
    } else {
      alert("Por favor, seleccione una fecha.");
    }
    this.router.navigate(["/portada"]);
  }

  reiniciarFormulario() {
    this.pasoActual = 1;
    this.entregaData = {
      finca: "",
      nomUsu: "",
      codUsu: "",
      marcas: this.piensos.map((marca) => ({
        ttcodmar: marca.ttcodmar,
        ttdesmar: marca.ttdesmar,
        tipos: marca.tipos.map((tipo) => ({
          ttcodtip: tipo.ttcodtip,
          ttdestip: tipo.ttdestip,
          cantidad: 0,
        })),
      })),
      formato: "",
      observaciones: "",
      fecha: null,
    };
  }

  persiana(): void {
    $("#wrapper").toggleClass("toggled");
  }
}
